// extracted by mini-css-extract-plugin
export var body = "_ni-8";
export var button = "_ni-0";
export var closeButton = "_ni-5";
export var content = "_ni-3";
export var empty = "_ni-f";
export var grid = "_ni-c";
export var header = "_ni-4";
export var icon = "_ni-1";
export var option = "_ni-d";
export var optionSelected = "_ni-e";
export var overlay = "_ni-2";
export var searchIcon = "_ni-a";
export var searchInput = "_ni-b";
export var searchWrapper = "_ni-9";
export var title = "_ni-6";
export var visuallyHidden = "_ni-7";